module.exports = __webpack_public_path__ + "img/card-bg-deco.a838fb58.png";